import { useTranslation } from "react-i18next";

interface ErrorFallbackProps {
  onReset: () => void;
}

function ErrorFallback({ onReset }: ErrorFallbackProps) {
  const { t } = useTranslation();
  return (
    <div role="alert" style={{ padding: "2rem", textAlign: "center" }}>
      <h1>{t("Something went wrong")}</h1>
      <p>{t("An unexpected error occurred. Please try again.")}</p>
      <button onClick={onReset}>{t("Try again")}</button>
    </div>
  );
}

export default ErrorFallback;
